import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ChainedBackend from "i18next-chained-backend";
import HttpBackend from "i18next-http-backend";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";

i18n
    .use(initReactI18next)
    .use(I18nextBrowserLanguageDetector)
    .use(ChainedBackend)
    .init({
        fallbackLng: ["en", "ru"],
        detection: {
            order: ['cookie', 'navigator'],
        },
        backend: {
            backends: [
                HttpBackend,
            ],
            backendOptions: [{
                loadPath: '/locales/{{lng}}/{{ns}}.json'
            }]
        },

        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;